<script setup lang="ts">
import {ELO_LOCALES, getDefaultLocale, getSelectedLocale, pickLocaleFrom, setLocale} from "../ts/translations";
import {computed, nextTick, queueJob, ref, watch, getCurrentInstance} from "vue";

const props = defineProps(['ui_locales']);
const result_ui_locales = computed(() => {
  if (!props.ui_locales) {
    return ELO_LOCALES;
  }
  return props.ui_locales;
});

const selectedLocale = defineModel()

watch(selectedLocale, async (newVal) => {
  console.log('selectedLocale', newVal);
  await setLocale(newVal);
});

const localeLabels = {
  "cs": "Česky",
  "da": "Dansk",
  "de": "Deutsch",
  "el": "Ελληνικά",
  "en": "English",
  "es": "Español (Internacional)",
  "es-419": "Español (Latinoamericano)",
  "fi": "Suomi",
  "fr": "Français",
  "hu": "Magyar",
  "id": "Bahasa Indonesia",
  "it": "Italiano",
  "nl": "Nederlands",
  "pl": "Polski",
  "pt": "Português",
  "pt-BR": "Português (Brasil)",
  "ro": "Română",
  "sk": "Slovensky",
  "sr": "Srpski",
  "sr-Cyrl": "\u0441\u0440\u043F\u0441\u043A\u0438",
  "tr": "Türkçe"
}
</script>

<template>
  <b-dropdown
      scrollable
      :max-height="300"
      position="is-top-left"
      v-model="selectedLocale"
      aria-role="locale-selector">
    <template #trigger>
      <b-button data-test-id="locale-selector"
          class="no-border"
          :label="'🌐 ' + localeLabels[selectedLocale]"
          type="is-secondary"
          icon-pack="e-icon"
          icon-right="angle-down" />
    </template>

    <template v-for="locale in result_ui_locales">
      <b-dropdown-item :value="locale" aria-role="listitem" :data-test-id="'locale-' + locale">{{localeLabels[locale]}}</b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<style>
.dropdown-menu {
  border: 1px solid #ccc;
}
</style>
